export default "__VITE_ASSET__Dh7rz$Io__"